"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.systemConfigInfo = systemConfigInfo;
exports.systemConfigIntegrityCheck = systemConfigIntegrityCheck;
exports.systemConfigSave = systemConfigSave;
exports.systemConfigSyncTenantsFromDefault = systemConfigSyncTenantsFromDefault;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | A2 [ A2赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.A2.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed A2并不是自由软件，未经许可不能去掉A2相关版权
// +----------------------------------------------------------------------
// | Author: A2 Team <admin@A2.com>
// +----------------------------------------------------------------------

function systemConfigInfo(pram) {
  var data = {
    formId: pram.id,
    tenantId: pram.tenantId
  };
  return (0, _request.default)({
    url: '/admin/system/tenantDefaultConfig/info',
    method: 'GET',
    params: data
  });
}
function systemConfigSave(pram) {
  return (0, _request.default)({
    url: '/admin/system/tenantDefaultConfig/save/form',
    method: 'POST',
    data: pram
  });
}

/** 默认配置与各租户配置完整性巡检（formIds 逗号分隔） */
function systemConfigIntegrityCheck(pram) {
  return (0, _request.default)({
    url: '/admin/system/tenantDefaultConfig/integrity',
    method: 'GET',
    params: {
      formIds: pram.formIds
    }
  });
}

/** 将默认配置复制到租户：按 formId 补缺失 name；可选 name 仅同步单个字段 */
function systemConfigSyncTenantsFromDefault(pram) {
  var params = {
    formId: pram.formId
  };
  if (pram.name != null && pram.name !== '') {
    params.name = pram.name;
  }
  return (0, _request.default)({
    url: '/admin/system/tenantDefaultConfig/syncTenantsFromDefault',
    method: 'POST',
    params: params
  });
}